import React from 'react';
import { Container } from 'react-bootstrap';
import { FormHeading, Well } from '../../form';
import LoginForm from '../../login';
import VisitorLoginForm from './VisitorLoginForm';
import attemptVisitorLogin from './attemptVisitorLogin';
import schema from './schema';

export const VisitorLoginPage: React.FC = () => (
  <Container>
    <Well>
      <FormHeading title="Visitor Login" backPath="/" />
      <LoginForm
        initialValues={{ pin: '' }}
        validationSchema={schema}
        promise={attemptVisitorLogin}
        redirectPath="/visitor"
      >
        <VisitorLoginForm />
      </LoginForm>
    </Well>
  </Container>
);
